export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';